export default () => ({
  isInDevelopmentMode: !!window.webpackHotUpdate,
  initialized: false,
  clientVersion: process.env.VUE_APP_RELEASE,
  jobDataLastFetch: null,
})
